import luiEn from './en.js'
import luiZh from './zh-CN.js'
import End2End from '@jdl/end2end-track'

export default {
  en_US: {
    ...luiEn,
    // @ts-ignore
    ...(End2End.LocaleMessage.en_US || {}),
    iTMSprivateNumber: 'Private Number Management',
    emailTemplateVersionManagement: 'Email Template Version List',
    smsTemplateVersionManagement: 'SMS Template Version List',
    unAssignTaskGroupDetail: 'Unassigned Task Group Details',
    EmailTemplateManagement: 'Email Template Management',
    SmsTemplateManagement: 'SMS Template Management',
    iTMSsmsTemplateManagement: 'SMS Template Management',
    iTMSemailTemplateManagement: 'Email Template Management',
    iTMSNotifyLog: 'Notification Log',
    NotifyLog: 'Notification Log',
    TemplateSmsManagement: 'SMS Template Detail',
    emailTemplateDetailManagement: 'Email Template Detail',
    ITMSwayTraceImport: 'Waybill Track Import',
    importQuotationItms: 'Batch Import Quotations',
    importBillMoneyWeight: 'Batch entry of billing weight',
    iTMSfeeMsgLog: 'Billing Message Query',
    errorTaskAdd: 'Exception Proof',
    errorTaskDetail: 'Exception Detail',
    "errorTaskDetails": "Exception Task Details",
    "errorTaskList": "Exception Task",
    "ITMSdmsTaskCenter": "Task Center",
    'driverMap.index.596360-0': 'Current Location',
    'driverMap.index.596360-1': 'Re-delivery',
    'driverMap.index.596360-2': 'Delivered',
    'driverMap.index.596360-3': 'Rejected',
    'driverMap.index.596360-4': 'Incomplete',
    'vehicleTrajectory.index.551792-0': 'GPS Tracking',
    'vehicleTrajectory.index.551792-1': 'APP Tracking',
    'vehicleTrajectory.index.551792-2': 'Shipment Task No.',
    'vehicleTrajectory.index.551792-3': 'Vehicle Plate No.',
    'vehicleTrajectory.index.551792-4': 'Start Time',
    'vehicleTrajectory.index.551792-5': 'End Time',
    'vehicleTrajectory.index.551792-6': 'GPS Device No.',
    'vehicleTrajectory.index.890369-1': 'Shipment Task has not started yet',
    'vehicleTrajectory.index.890369-2': 'Failed to query Shipment Task!',
    'vehicleTrajectory.index.890369-0': '查询任务单行车站点详情',
    'vehicleTrajectory.index.890369-3': '查询任务单行车轨迹',
    ITMSHwlyCarPlanList: 'Truck Rental Plan',
    HwlyCarPlanCreate: 'Create Truck Rental Plan',
    HwlyCarPlanView: 'View Truck Rental Plan',
    HwlyCarPlanEdit: 'Edit Truck Rental Plan',
    IDMSsupplementReository: 'Supplement',
    IMDSLabelPrint: 'Label Print',
    CBRouteTransTaskDetail: 'Main Route Transportation Task Details',
    CBRouteTransTaskEdit: 'Edit Main Route Transportation Task',
    CBRouteTransTaskAdd: 'Add Main Route Transportation Task',
    CBMainRouteTransTaskImportTrace: 'Upload Main Route Transportation Task Tracking',
    CBMainRouteTransTaskList: 'Main Route Transportation Tasks',
    CrossBorderPortDeliveryOrderAdd: 'Add Port Delivery Task',
    CrossBorderPortDeliveryOrderEdit: 'Edit Port Delivery Task',
    CrossBorderPortDeliveryOrderDetail: 'Port Delivery Task Details',
    CrossBorderPortDeliveryOrder: 'Port Delivery Tasks',

    iTMSStaffManagement: 'Staff',
    iTMSStaffManagementtms: 'Staff',
    iTMSStaffManagement3pl: 'Staff',
    iTMSStaffManagementdms: 'Staff',
    ITMSTcscWarehouseDeliveryOrderAdd: 'Add New Warehouse Delivery Task',
    'noPermission.index.692881-0': 'iTMS',
    'noPermission.index.692881-1': 'Please log in again',
    'noPermission.index.692881-2': 'Dear User, Hi!',
    'noPermission.index.692881-3': 'The new version of the iTMS(itms.jd.com) is now officially online. To better enjoy the new service experience, please contact your sales representative to activate it',
    'noPermission.index.692881-4': 'Since your current account has not been granted access to the new version of the iTMS, you will be redirected to the old version',
    'noPermission.index.692881-5': 'Please contact your sales representative or join the ME group for assistance',
    'el.table.emptyText': 'No Data yet',
    'components.trackingCard.458349-4': 'No Data yet',
    'Header.index.745653-0': '简体中文',
    'Header.index.745653-1': 'Username',
    'Header.index.745653-2': 'Log out',
    'Header.index.745653-3': 'Copy successful',
    'Header.index.745653-4': 'This browser does not support automatic copying',
    'Aside.Item.962789-0': 'Unfavorite',
    'Aside.Item.962789-1': 'Favorite',
    uploadRouteScheduling: 'Import scheduling',
    storeManagerUpload: 'Storage location upload',
    'driverMap.index.745770-0': 'The driver has no trajectory today',
    'driverMap.index.793895-0': 'Please enter',
    'driverMap.index.793895-1': 'In progress',
    'driverMap.index.793895-2': 'Delivered',
    'driverMap.index.793895-3': 'Picked up',
    'admissionFenceMapDisplay.index.657910-0': 'Please enter',
    'lib.request.334593-0': 'Network congestion, please try again later~',
    'lib.request.334593-1': 'Your account has security risks, please contact customer service~',
    'lib.request.334593-2': 'The system is having a hiccup, please try again later~',
    'vehicleTrajectory.index.887816-0': 'Vehicle Tracking',
    'vehicleTrajectory.index.887816-1': 'Please enter',
    'vehicleTrajectory.index.887816-2': 'Vehicle:',
    'vehicleTrajectory.index.887816-3': 'Driver:',

    carManageNewEdit: 'View/Edit Vehicle',
    ITMSOverseaTrans: 'Overseas Land Shipment',
    ITMSTCManage: 'Capacity Management',
    ITMSWorkbench: 'Scheduling Workbench',
    ITMSDemand: 'Shipment Request',
    ITMSHwlyTask: 'Shipment Task',
    ITMSVehicleTrajectory: 'Vehicle Tracking',
    ITMSOverseasTransExceptionCenter: 'Incident Center',
    ITMSCarManage: 'Vehicle Management',
    ITMSDriverManage: 'Driver Vehicle Bind',
    hwlyTaskDetail: 'Shipment Task Detail',
    hwlyDemandDetail: 'Shipment Request Detail',
    hwlyWorkbenchBatchDispatch: 'Shipment Scheduling',
    hwlyWorkbenchDemandAdd: 'Create Shipment Request',

    homePageSite: 'Pick-up & delivery home',
    homePage: 'Home',
    mapTrackingCode: 'Tracking',
    TaskWorkbench: 'Task workspace ',
    EmptyRouteScheduling: 'Empty route scheduling',
    CustomerServiceTicketTask: 'Customer service tickets ',
    AddressChangeOrderReplacementTask: 'Address change & reprint ',
    CancelInterceptionTask: 'Cancel interception task',

    DispatchManagement: 'Station',
    PersonnelManagement: 'Personnel management',
    DriverBasicInformation: 'Driver info ',
    DriverMap: 'Driver map',
    OperationsCenter: 'Operations center ',
    UnifiedPersonnelEfficiencyDashboard: 'Personnel efficiency dashboard',
    UnifiedRetentionDashboard: 'Site management dashboard ',
    UnifiedAccountsReceivableDashboard: 'Accounts receivable dashboard',
    UnifiedExceptionDashboard: 'Exception dashboard ',
    UnifiedPickupDashboard: 'Pickup dashboard',
    UnifiedDeliveryDashboard: 'Delivery dashboard',
    UnifiedFuelSubsidiesDashboard: 'Unified fuel subsidies dashboard',
    ExportHistory: 'Export Records',
    RouteManagement: 'Route area management',
    RouteScheduling: 'Route scheduling',
    AdmissionFenceMapDisplay: 'Route fencing',
    ZoneTaskAllocation: 'Task center',
    PrintSupplement: 'Label reprint ',
    ReverseSchedule: 'Reverse Schedule',
    StoreManager: 'Storage management ',
    IDMSStoreManager: 'Storage management',
    IDMSStoreManagerUpload: 'Storage location upload',
    ReAssignUnAssginTask: 'Task Reassignment',
    UnCheckPickupEndDetail: 'Pickup terminated detail',
    StoreManagerUpload: 'Storage Location Upload',
    MapTracking: 'Tracking',
    IDMSEndToEndTracking: 'Tracking',
    Supplement: 'Auxiliary Functions',
    PayMethodModify: 'Payment method',
    PayMethodModifyEdit: 'Payment method edit',
    Optlog: 'OTP Logs',

    Tcsc: 'Delivery to Warehouse',
    ITMSTcscWaybill: 'Waybill',
    ITMSTcscWaybillDetail: 'Waybill Detail',
    TMSTcscCapacityOrder: 'Booking',
    TMSTcscCapacityOrderDetail: 'Booking Detail',
    ITMSTcscTrunkLineOrder: 'Trunk Shipment',
    ITMSTcscTrunkLineOrderDetail: 'TS Detail',
    ITMSTcscPortDeliveryOrder: 'Port Shipment',
    ITMSTcscPortDeliveryOrderDetail: 'PS Detail',
    ITMSTcscWarehouseDeliveryOrder: 'Warehouse Shipment',
    ITMSTcscWarehouseDeliveryOrderDetail: 'WS Detail',
    ITMSTcscLogisticsPlanList: 'Logistics Plan',
    ITMSTcscLogisticsPlanDetail: 'LP Detail',
    ALTraceReFetch: 'Trace ReFetch',
    // 运输管理
    ITMSTransportationManage: 'Transportation',
    ITMSCrossBorderFreight: 'Cross-Border Transportation',
    ITMSSupplierServiceOperation: 'Pre-port Operation',
    ITMSSupplierServiceCrossBorderList: 'Shipment List',
    ITMSCrossBorderPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ITMSRouteOperation: 'Console Management',
    ITMSRouteTrunkCycle: 'Vessel In Schedule',
    ITMSRoutePreStowage: 'Pre-Loaded',
    ITMSRouteLclStowage: 'Console List',
    ITMSbasic: 'Basic Info',
    ITMSbusinessGroup: 'Business Service Team',
    ITMSserviceProvider: 'Partner Info',
    ITMScountAndCity: 'Countries and Cities',
    ITMSportInfo: 'Port Info',
    ITMSshipCompany: 'Shipping Company',
    ITMSairCompany: 'Airline Company',
    ITMScabinet: 'Container Info',
    ITMSimporter: 'Internal Importer Agent',
    ITMSreceiver: 'Internal Consignee',
    ITMSaccountManagement: 'Account Management',
    ITMSfeeType: 'Fee Basic Info',
    ITMSAirTransportation: 'Air Transportation',
    ITMSBookingFlightData: 'Flight Management',
    ITMSBookingFlightWorkload: 'Flight Workload',
    ITMSBookingFlightPlan: 'Flight In Scheduel',
    ITMSBookingFlightInfo: 'Flight Info',
    ITMSBookingDistributePlan: 'Quota Plan',
    ITMSBookingTicketManage: 'Tickets Management',
    ITMSBookingTicketType: 'Tickets Type',
    ITMSBookingTicketInfo: 'Tickets Info',
    ITMSOperationalAnalysisReport: 'Operation Analysis Report',
    ITMSCostVerification: 'Invoice Verification',
    ItmsCostVerificationDetail: 'Invoice Verification-Detail',
    ITMSFeeList: 'Rate Management',
    ITMSLadTrackReport: 'MBL Tracking Log',
    Itms_LadTrackLog: 'Trace Log',
    ITMSOrderLog: 'Order Log',
    Itms_OrderLog: 'Order Log',
    ITMSBookingTicketInventory: 'Ticket Inventory',
    ITMSBookingInfo: 'Order Management',
    ITMSBookingPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ITMSCrossBorderTrackImport: 'Track Import',
    ITMSBookingShowInfo: 'Shipment Request',
    ITMSBookingAirlineApproval: 'Booking Approval',
    ITMSBookingChange: 'Rebooking',
    ITMSBookingShowWaybillInfo: 'Waybill Query',
    ITMSBookingBasicData: 'Basic Info',
    ITMSBookingCityThreeWordCodeInfo: 'City Code',
    ITMSBookingDictionaryInfo: 'Dictionaries Management',
    ITMSBookingCarrierInfo: 'Carrier',
    ITMSBookingAirplaneModelInfo: 'Aircraft Type Management',
    ITMSBookingCustomerInfo: 'Customer Management',
    ITMSBookingServiceProvider: 'Partner Info',
    ITMSLandTransportation: 'Land Shipment',
    ITMSTransportationDocumentServices: 'Shipment Management',
    ITMSTransportationDocument: 'Shipment Request',
    ITMSTransportationPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ITMSTransportationTaskManage: 'Shipment Task Management',
    ITMSTransportationTaskListManage: 'Shipment Task',
    ITMSTransportationBasicData: 'General Info',
    ITMSTransportationCarManage: 'Vehicle Management',
    ITMSTransportationDriverManage: 'Driver Management',
    ITMSTransportationMyBusiness: 'Merchant Bundling',
    ITMSTransportationMotorcadeManage: 'Fleet Management',
    ITMSTransportationDictionaryInfo: 'System Rule(Dictionary)',
    ITMSSmallPackageTransportation: 'Cross-border Express',
    ITMSBigSmallPackageManage: 'Order Management',
    ITMSTrunkIinePackageInfoHome: 'Package List',
    ITMSTrunkIinePackageBigHome: 'Container List',
    ITMSTrunkIineBillInfo: 'B/L Management',
    ITMSTrunkIineShowBillInfo: 'B/L List',
    ITMSTrunkIineShowBillInfoEx: 'Customs Declaration',
    ITMSTrunkIineReport: 'Report Management',
    ITMSTrunkIineReportHome: 'Express Air Timeliness Chart',
    ITMSSystemManage: 'System Management',
    ITMSSystemData: 'System Configuration',
    ITMSSystemDataDictionaryInfo: 'Dictionary Config',
    Itms_AutoBillConfig: 'Auto-rating Configuration',
    Itms_Postcode: 'Postcode Database',
    ItmsPostcode: 'Postcode Database',
    PLplatform: 'Logistics Partner',
    '3PL-platform': 'Logistics Partner',
    PLplatformlevel1: 'Partner Center',
    PLCarrier: 'SPP Config',
    PLCarriePrefix: 'Order No. Rules',
    PLConfigLable: 'Config',
    PLLogisticsProvider: 'Config Management',
    PLLogisticsProviderAttr: 'Attribute Management',
    PLParamValidation: 'Order Parameter Verification',
    PLwarningRule: 'Alert Rule',
    PLaccountNumber: 'Account Maintenance',
    PLqueryRule: 'Query Rule Maintenance',
    WBcarrierTrack3pl: 'Carrier Tracking Monitoring',
    PLcarrierTrack3pl: 'Carrier Trajectory Monitoring',
    SystemManagement: 'System Management',
    SMBaseInfo: 'Basic Config',
    SMFeedBack: 'Feedback',
    SMErrorMapping: 'Exception Handling Center',
    SMCountryConfig: 'National Config',
    SMTimelinessConfig: 'SPP Timeliness Configuration',
    SMSortingConfig: 'Sort Code Management',
    SMdictionary3pl: 'Dictionaries Management',
    SMToolManager: 'Tool Management',
    Itms_RedisTool: 'Cache Management',
    SMToolRedis: 'Cache Management',
    SMPlaceOrder: 'Order Management',
    PLBillingImport: 'Billing Import',
    SMRepushTrace: 'Trajectory Repush',
    SMwaybillQuery: 'Waybill Query',
    PLPeWex: 'Pewex Import',
    PLBillingImportOrderId: 'Order Billing Import',
    SMCodeConfiguration: 'Order Number Config',
    WBBidding: 'Waybill Center',
    WBWaybillQuery: 'Waybill Query',
    WBQueryOrderChain: 'Order Relationship Query',
    WBTrackInfo3pl: 'Logistics Tracking',
    WBReportManage: 'Monitoring Reports',
    WBWaybillMonitorNew3pl: 'Operations Monitoring Report',
    WBOrderCount3pl: 'Order Volume Statistics',
    WBPickUpCount3pl: 'Collection Volume',
    WBDeliveredCount3pl: 'Delivered Volume',
    WBwarningRuleDetail3pl: 'Warning Details',
    WBorderTrackStatistics3pl: 'Timely Operation Statistics',
    ALAbility: 'Capability Center',
    ALServiceProvider: 'Partner Management',
    ALSPInformation: 'Partner Info',
    PLBiddingManage: 'Bidding Document',
    PLDemand: 'Bidding Requirements',
    PLBondManage: 'Deposit Management',
    ALBaseInfo: 'Basic Config',
    PLContractList: 'Contract Management',
    PLsystemExecution: 'Auto-Execution Config',
    PLemailNotification: 'Email-Notify Config',
    PLbiddingWorkingGroup: 'Workgroup Config',
    ALDocumentCenter: 'Print Center',
    ALBaseTemplate: 'Template Basic Info',
    ALDocTemplate: 'Template Management',
    ALDocManager: 'Document Management',
    ALShowLabel: 'Label Management',
    ALBaseTemplate3: 'Template Management-V3.0',
    ALDocTemplate3: 'Data Source Management-V3.0',
    ALDocManager3: 'Template Print Configuration-V3.0',
    ALTrajectoManage: 'Tracking',
    ALStandardLable: 'Standard State',
    PLProviderManage: 'Original Node',
    PLMappLable: 'Original Node Mapping',
    PLMappingSchemeManagement: 'Mapping Scheme Management',
    PLInterfaceConfiguration: 'Interface Capability Configuration',
    ALPackLable: 'Merchant Node Packaging',
    PLTraceImport: 'Track Import',
    WBTrackQuery: 'Track Query',
    ALTraceQueryManage: 'Track Log',
    PLTraceImportB2: '2B Track Import',
    ALtrackSourceConfig: 'Track Source Config',
    PLCarrierConfig: 'Carrier Config',
    ITMSTransportationSingleList: 'Shipment Order(DANONE)',
    ITMSTransportationDemandOrderManagement: 'DN Consol Workbench',
    ITMSTransportationScheduleOrderManagement: 'DN Collaboration Management',
    ITMSTransportationGPSdevice: 'GPS Device',
    ITMSTransportationGPStrack: 'GPS Tracking Record',
    ITMSTransportationExportReportTemplate: 'Report Template',
    PLServiceSupplier: 'Partner Info',
    PLDepartmentAuth: 'Dep. Management',
    PLScatterFilings: 'Inquiry Management',
    PLBillingImportWaybill: 'Audit Trail',
    PL3PLTranslateList: 'Translation Management',
    SMExceptionHandle: 'Exception Handling Platform',
    SMcommonLog: 'Log Management ',
    SMaiTools: 'Service Provider AI Tools',
    SMServiceLog: 'Log Query',
    PrintingCenter: 'Printing',
    TrackingCenter: 'Tracking',
    OperationalMonitoring: 'Monitoring',
    SystemTools: 'Tools',
    ServiceProviderMasterData: 'Partner Master Data',
    ServiceProviderProcurement: 'Partner Bidding&Procurement',
    ServiceProviderContracts: 'Partner Contracts',
    ServiceProviderIntegration: 'Partner Integration',
    CommonTools: ' Business Tools',
    WaybillInquiry: 'Waybill Query',
    MonitoringReports: 'Monitoring Reports',
    BasicConfiguration: 'Basic Config',
    ToolManagement: 'Tool Management',
    LogisticsManagement: 'Distribution',
    WBWaybillMonitor3pl: 'Shipment Tracking',
    ITMSAnalysisReport: 'Business Tools',
    PLDockingManage: 'Docking Management',
    SMObtainTrackingNumber: 'Obtain the tracking number',
    ITMSSystemDataDictionaryInfo1: 'System Rule(Dictionary)',
    ITMSObtainTrackingNumber: 'Waybill Generating',
    WBObtainTrackingNumber: 'Waybill Assignment',
    PLObtainTrackingNumber: 'Waybill Assignment',
    iTMSAutoBillConfig: 'Auto-rating Configuration',
    // ITMSFirstCollection: 'POD parsing service',
    ITMSTransportationPodManagement: 'POD Batch Upload',
    ItmsCollectionListN: 'Collection request',
    ITMSFirstCollection: 'First mile collection',
    ItmsTransportTaskN: 'Transportation task',
    ItmsPickupChannelManagementN: 'Collection channel management',
    ItmsPickupScheduleManagementN: 'Collection cycle configuration',
    PLCollectionImport: 'Collection import',
    PLTrackEntryDetails: 'Track entry details',
    PLAnomalyMonitoringDetails: 'Exception Monitoring Detailed',
    ReportManageAnomalyProcessing: 'Exception Monitoring Handling',
    PLAnomalyMonitoring: 'Exception Monitoring Summary',
    aaa: 'name',
    // 运输管理
    'ITMS-TransportationManage': 'Transportation',
    ItmsTrunkIineManage: 'Trunk Iine Management',
    ItmsTrunkIinePackageInfo: 'Package List',
    ItmsTrunkIinePackageInfoHome: 'Small Bag List',
    ItmsTrunkIinePackageBig: 'Container List',
    ItmsTrunkIinePackageBigHome: 'Big Bag List',
    ItmsTrunkIineBillInfo: 'Lading Bill Management',
    ItmsTrunkIineShowBillInfo: 'B/L List',
    ItmsTrunkIineShowBillInfoEx: 'Customs Declaration',
    ItmsTrunkIineReport: 'Report Management',
    ItmsTrunkIineReportHome: 'Express Air Timeliness Chart',
    ItmsOtherManage: 'Other Management',
    ItmsOtherReviewManage: 'Code Review',
    ItmsOtherCardInfo: 'My Needs',
    ItmsOtherReviewInfo: 'My Review',
    ItmsOtherDataInfo: 'Data Management',
    ItmsOtherRunData: 'Data Operation',
    ItmsBookingManage: 'Aviation Management',
    ItmsBookingBasicData: 'Basic Info',
    ItmsBookingDictionaryInfo: 'Dictionaries Management',
    ItmsBookingCityThreeWordCodeInfo: 'City Code',
    ItmsBookingCarrierInfo: 'Carrier',
    ItmsBookingAirplaneModelInfo: 'Aircraft Type Management',
    ItmsBookingCustomerInfo: 'Customer Management',
    ItmsBookingServiceProvider: 'Partner Info',
    ItmsBookingFlightData: 'Flight Data',
    ItmsBookingFlightWorkload: 'Flight Workload',
    ItmsBookingFlightPlan: 'Flight In Scheduel',
    ItmsBookingFlightInfo: 'Flight Info',
    ItmsBookingDistributePlan: 'Quota Plan',
    ItmsBookingTicketManage: 'Tickets Management',
    ItmsBookingTicketType: 'Tickets Type',
    ItmsBookingTicketInfo: 'Tickets Info',
    ItmsBookingTicketDistribute: 'Ticket Distribute',
    ItmsBookingClaimAndRefund: 'Claim And Refund',
    ItmsBookingTicketInventory: 'Ticket Inventory',
    ItmsBookingInfo: 'Booking Management',
    ItmsBookingShowInfo: 'Transport Order Service',
    ItmsBookingAirlineApproval: 'Booking Approval',
    ItmsBookingChange: 'Rebooking',
    ItmsBookingPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ItmsBookingWaybillInfo: 'Waybill Management',
    ItmsBookingShowWaybillInfo: 'Waybill Query',
    ItmsTransportationManage: 'Land Transport Management',
    ItmsTransportationDocumentServices: 'Transport Order Service',
    ItmsTransportationDocument: 'Shipment Request',
    ItmsTransportationSingleList: 'Shipment Order(DANONE)',
    ItmsTransportationDemandOrderManagement: 'DN Consol Workbench',
    ItmsTransportationScheduleOrderManagement: 'DN Collaboration Management',
    ItmsTransportationScheduleOrderManagementDetail: 'DN Collaboration Details',
    ItmsTransportationPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ItmsTransportationTaskManage: 'Task Management',
    ItmsTransportationTaskListManage: 'Shipment Task',
    ItmsTransportationBasicData: 'Basic Info',
    ItmsTransportationCarManage: 'Vehicle Management',
    ItmsTransportationDriverManage: 'Driver Management',
    ItmsTransportationMotorcadeManage: 'Fleet Management',
    ItmsTransportationMyBusiness: 'Merchant Bundling',
    ItmsTransportationDictionaryInfo: 'System Rule(Dictionary)',
    ItmsTransportationGPSdevice: 'GPS Device',
    ItmsTransportationGPStrack: 'GPS Tracking Record',
    ItmsTransportationExportReportTemplate: 'Report Template',
    ItmsTransportationExportReportTemplateAdd: 'Add Report Template',
    ItmsTransportationExportReportTemplateEdit: 'Edit Report Template',
    ItmsSupplierServiceOperation: 'Pre-port Operation',
    ItmsSupplierServiceCrossBorderList: 'Shipment List',
    ItmsCrossBorderPlaceOrdersForCustomers: 'Booking(Internal Entrance)',
    ItmsTransportationPodManagement: 'POD Batch Upload',
    ItmsExcelImport: 'Excel Import',
    ItmsPortBatch: 'Excel Import',
    ItmsManualEntry: 'Manual Entry',
    ItmsScatterMining: 'Service Provider Quotation Request',
    ItmsCrossBorderTrackImport: 'Track Import',
    ItmsRouteOperation: 'Route Operation',
    ItmsRouteTrunkCycle: 'Vessel In Schedule',
    ItmsRoutePreStowage: 'Pre-Loaded',
    ItmsRouteLclStowage: 'Console List',
    ItmsSystemManage: 'System Management',
    ItmsAnalysisReportFeeList: 'Analysis Report',
    ItmsCostVerification: 'Invoice Verification',
    ItmsFeeList: 'Rate Management',
    ItmsLadTrackReport: 'MBL Tracking Log',
    ItmsOrderLog: 'Order Log',
    ItmsBasicData: 'Basic Info',
    ItmsCrossBorderBasicDataServiceProvider: 'Partner Info',
    ItmsCrossBorderBasicDataBusinessServiceTeam: 'Business Service Team',
    ItmsCrossBorderBasicDataNationalAndCity: 'Nation&City',
    ItmsCrossBorderBasicDataPort: 'Port Info',
    ItmsCrossBorderBasicDataShippingCompany: 'Shipping Company',
    ItmsCrossBorderBasicDataAirlines: 'Airline Company',
    ItmsCrossBorderBasicDataContainer: 'Container',
    ItmsCrossBorderBasicDataImportser: 'Internal Importer Agent',
    ItmsCrossBorderBasicDataConsignee: 'Internal Consignee',
    ItmsCrossBorderBasicDataAccountManage: 'Account Management',
    ItmsCrossBorderBasicDataCostTypes: 'Fee Basic Info',
    ItmsSystemData: 'System Rule(Dictionary)',
    ItmsObtainTrackingNumber: 'Waybill Generating',
    ItmsSystemDataDictionaryInfo: 'Dictionary Config',
    ITMSsenderReceiverInfo: 'Notify Parties',
    "ITMSsenderReceiverInfoDetail": "Notify Parties Details",
    "ITMSsenderReceiverInfoAdd": "Add Notify Parties",
    "ITMSsenderReceiverInfoEdit": "Edit Notify Parties",
    ItmsAnalysisReport: 'Analysis Report',
    ItmsOperationalAnalysisReport: 'Operation Analysis Report',
    // 头程
    ITMSAddCollectionNeed: 'Add new collection request',
    ITMSEditCollectionNeed: 'Modify collection request',
    ITMSCheckCollectionNeed: 'View collection request',
    ITMSCollectionList: 'Collection request',
    ITMSCreateTransportTask: 'Create task order',
    ItmsTransportTask: 'Transportation task',
    ITMSTransportTaskInfo: 'Transportation task details',
    pickupScheduleManagement: 'Pickup Cycle Configuration',
    pickupChannelManagement: 'Customer Pickup Channel Configuration',
    ITMSAddPickupSchedule: 'Add new collection cycle',
    ITMSEditPickupSchedule: 'Edit collection cycle',
    ItmsManualEntryFop: 'Manual Entry',
    'SMdictionary-3pl': 'Dictionaries Management',
    BookingApprovalDialog: 'Booking Approval',
    BookingCBAOperation: 'CBA Operation',
    BookingStowage: 'Check Cabin Order',
    BookingSpecifics: 'Order Details',
    BookingAirlineBooking: 'Airline Booking',
    CrossBorderListMsg: 'Base Info',
    RouteLclStowageInfo: 'LCL Info',
    TransportationDocumentInfo: 'Shipment Request Details',
    CreateTransNeedBill: 'Create Trans Need Bill',
    ModifyTransNeedBill: 'Modify Trans Need Bill',
    MergeCreateTaskBill: 'Merge Create Task Bill',
    SplitCreateTaskBill: 'Split Create Task Bill',
    TransportationTaskListInfo: 'Shipment Task Details',
    TransportationTaskOverseasSendCar: 'Send Car',
    TransportationSingleListDetails: 'singleDetails',
    ITMSTransportationPromptManage: 'POD Batch Upload',
    ITMSReceivableBilling: 'Auto-rating Configuration',
    noPermission: 'No Permission',
    welcomeHomePage: 'Welcome to iTMS!',
    ConfigCenter: 'Configuration',
    AutomatedEquipment: 'Automated equipment',
    WeighMeasureFlowMeter: 'Weight log',
    PackageAggregationRules: 'Consolidation rules',
    BundlingLimitConfig: 'Consolidation quantity',
    OperationsReport: 'Operations Report',
    ErrorManage: 'Exception management',
    ITMSEndToEndTracking: 'Tracking',
    PostCodeConfiguration: 'Position code',
    IDMSMenuPostCodeConfiguration: 'Position code',

    'components.baseInfoCard.290487-0': 'Code',
    'components.baseInfoCard.290487-1': 'Name',
    'components.baseInfoCard.290487-2': 'Yes',
    'components.baseInfoCard.290487-3': 'No',
    'components.recordCard.329012-0': 'items',
    'components.recordCard.329012-1': 'Query failed',
    'components.search.413897-0': 'Please enter JDW number/FS number/tail number',
    'components.search.413897-1': 'Search',
    'components.search.413897-2': 'Query history',
    'components.search.413897-3': 'Waybill number',
    'components.search.413897-4': 'Please enter the waybill number',
    'components.search.413897-5': 'User information not retrieved',
    'components.search.413897-6': 'User storage information is not an array',
    'components.trackingCard.458349-0': 'Local time',
    'components.trackingCard.458349-1': 'Latest tracking',
    'components.trackingCard.458349-2': 'Default node',
    'components.trackingCard.458349-3': 'Track query failed',
    'mapTracking.const.548220-0': 'Basic information',
    'mapTracking.const.548220-1': 'Order number',
    'mapTracking.const.548220-2': 'Customer order number',
    'mapTracking.const.548220-3': 'Customer parcel number',
    'mapTracking.const.548220-4': 'Last mile waybill nnumber',
    'mapTracking.const.548220-5': 'Product name',
    'mapTracking.const.548220-6': 'Product code',
    'mapTracking.const.548220-7': 'Service provider product',
    'mapTracking.const.548220-8': 'Order time',
    'mapTracking.const.548220-9': 'Customer code',
    'mapTracking.const.548220-10': 'Customer name',
    'mapTracking.const.548220-11': 'Salesperson',
    'mapTracking.const.548220-12': 'Is COD',
    'mapTracking.const.548220-13': 'COD amount',
    'mapTracking.const.548220-14': 'Tax payment method',
    'mapTracking.const.548220-15': 'Sender information',
    'mapTracking.const.548220-16': 'Sender name',
    'mapTracking.const.548220-17': 'Sender company',
    'mapTracking.const.548220-18': 'Sender mobile',
    'mapTracking.const.548220-19': 'Sender phone',
    'mapTracking.const.548220-20': 'Sender email',
    'mapTracking.const.548220-21': 'Sender country/region',
    'mapTracking.const.548220-22': 'Sender full address',
    'mapTracking.const.548220-23': 'Sender address latitude and longitude',
    'mapTracking.const.548220-24': 'Recipient information',
    'mapTracking.const.548220-25': 'Recipient name',
    'mapTracking.const.548220-26': 'Recipient company',
    'mapTracking.const.548220-27': 'Recipient mobile',
    'mapTracking.const.548220-28': 'Recipient phone',
    'mapTracking.const.548220-29': 'Recipient email',
    'mapTracking.const.548220-30': 'Recipient country/region',
    'mapTracking.const.548220-31': 'Recipient postal code',
    'mapTracking.const.548220-32': 'Recipient full address',
    'mapTracking.const.548220-33': 'Recipient address latitude and longitude',
    'mapTracking.const.548220-34': 'Weighing information',
    'mapTracking.const.548220-35': 'JD weight KG',
    'mapTracking.const.548220-36': 'JD length CM',
    'mapTracking.const.548220-37': 'JD width CM',
    'mapTracking.const.548220-38': 'JD height CM',
    'mapTracking.const.548220-39': 'JD volume cm3',
    'mapTracking.const.548220-40': 'Customer declared weight KG',
    'mapTracking.const.548220-41': 'Customer declared length CM',
    'mapTracking.const.548220-42': 'Customer declared width CM',
    'mapTracking.const.548220-43': 'Customer declared height CM',
    'mapTracking.const.548220-44': 'Customer declared volume cm3',
    'mapTracking.const.548220-45': 'Commodity information',
    'mapTracking.const.548220-46': 'Commodity name',
    'mapTracking.const.548220-47': 'Commodity SKU',
    'mapTracking.const.548220-48': 'Commodity quantity',
    'mapTracking.const.548220-49': 'Commodity HSCODE',
    'mapTracking.const.548220-50': 'Commodity weight',
    'mapTracking.const.548220-51': 'Commodity weight unit',
    'mapTracking.const.548220-52': 'Declared value',
    'mapTracking.const.548220-53': 'Image',
    'mapTracking.const.548220-54': 'Open box inspection',
    'mapTracking.const.548220-55': 'Weight measurement',
    'mapTracking.const.548220-56': 'Change record',
    'mapTracking.const.548220-57': 'Operator',
    'mapTracking.const.548220-58': 'Operation source',
    'mapTracking.const.548220-59': 'Operation time',
    'mapTracking.const.548220-60': 'Content before modification',
    'mapTracking.const.548220-61': 'Content after modification',
    'mapTracking.const.548220-62': 'Order acceptance message',
    'mapTracking.const.548220-63': 'Order placement message',
    'mapTracking.const.548220-64': 'All',
    'mapTracking.const.548220-65': 'Problem record',
    'mapTracking.const.548220-66': 'Customer service record',
    'mapTracking.const.548220-67': 'Delivery record',
    'mapTracking.const.548220-68': 'Sender Postal Code',
    'mapTracking.const.548220-69': 'Driver Notes',
    'src.propsMixin.283206-0': 'Photos of super layer',
    'src.propsMixin.283206-1': 'Photos of dismantling',
    'src.propsMixin.283206-2': 'Value-added services',
    'mapTracking.dialog.604373-0': 'Full tracking',
    'mapTracking.propsMixin.706968-0': 'JDW number',
    'mapTracking.propsMixin.706968-1': 'FS number',
    'mapTracking.propsMixin.706968-2': 'Last mile waybill number',
    'mapTracking.const.759985-0': 'Pickup/Delivery Site',

    'vehicleTrajectory.index.761936-0': 'Merchant Address',
    'Header.TopMenu.713567-0': 'More',
    'home.index.925578-0': 'Welcome to iTMS',
    'mapTracking.const.548221-1': 'DDP (Delivered Duty Paid)',
    'mapTracking.const.548221-2': 'DDU (Delivered Duty Unpaid)',
    'mapTracking.const.548221-3': 'Third-Party Payment',

    'mapTracking.const.759985-1': 'Pre-sorting Pickup Site Name',
    'mapTracking.const.759985-2': 'Pre-sorting Pickup Site ID',
    'mapTracking.const.759985-3': 'Pre-sorting Pickup Site Code',
    'mapTracking.const.759985-4': 'Pre-sorting Delivery Site Name',
    'mapTracking.const.759985-5': 'Pre-sorting Delivery Site ID',
    'mapTracking.const.759985-6': 'Pre-sorting Delivery Site Code',
    'src.propsMixin.279961-0': 'SO Number',
    'src.propsMixin.279961-1': 'Network Type',
    'src.propsMixin.279961-2': 'Self-Pickup Flag',
    'src.propsMixin.279961-3': 'Origin Warehouse ID',
    'src.propsMixin.279961-4': 'Destination Warehouse ID',
    'src.propsMixin.279961-5': 'Declared Value Currency',
    'src.propsMixin.279961-6': 'Combined Delivery-Installation Flag',
    'src.propsMixin.279961-7': 'Recycling Service Flag',
    'src.propsMixin.279961-8': 'Adult Signature Service Flag',
    'src.propsMixin.279961-9': 'High-Value Service Flag',
    'src.propsMixin.279961-10': 'Paper Signature Slip',
    'src.propsMixin.279961-11': '6-Side Product Packaging Photos',
    'src.propsMixin.279961-12': 'Internal Packaging Photos',
    'src.propsMixin.279961-13': 'Recycling Certificate',
    'src.propsMixin.279961-14': 'Wall Mount or Base Installation',
    'src.propsMixin.279961-15': 'Face-to-Face Signature Notes & Sign-off',
    'src.propsMixin.279961-16': 'Nameplate SN Code & Environment',
    'src.propsMixin.279961-17': 'Signal',
    'src.propsMixin.279961-18': 'Rejection Photos',
    'src.propsMixin.279961-19': 'Redelivery Photos',
    'src.propsMixin.279961-20': 'Pickup Photos',
    'src.propsMixin.279961-21': 'Repick Photos',
    'src.propsMixin.279961-22': 'Pickup Termination',
    'src.propsMixin.279961-23': 'POS Receipt',
    'src.propsMixin.279961-24': 'COPY',
    'src.propsMixin.279961-25': 'INVOICE',
    'src.propsMixin.279961-26': 'MANIFEST',
    'src.propsMixin.279961-27': 'Terminal Exception',
    'src.propsMixin.279961-28': 'Scrapped',
    'components.baseInfoCard.500583-0': 'Small & Medium Parcels',
    'components.baseInfoCard.500583-1': 'Large Parcels',
    'components.baseInfoCard.500583-2': 'Cold Chain',
    'components.baseInfoCard.500583-3': 'Delivery',
    'components.baseInfoCard.500583-4': 'Self-Operated Pickup',
    'components.baseInfoCard.500583-5': 'Franchised Pickup',
    'components.baseInfoCard.500583-6': 'Third-Party Pickup',
    'tableList.tableList.661328-0': 'No Installation Service',
    'tableList.tableList.661328-1': 'Combined Delivery-Installation',
    'tableList.tableList.661328-2': 'With Recycling Service',
    'tableList.tableList.661328-3': 'No',
    'tableList.tableList.661328-4': 'Yes',
    LargeServiceMapping: 'Large Value-added Service Mapping',
    EditLargeServiceMapping: 'Edit Large Value-added Service Mapping',
    AddLargeServiceMapping: 'Add Large Value-added Service Mapping',
    'Header.index.531889-1': 'Asia-Pacific Site',
    'Header.index.531889-2': 'Europe Site',
    iTMSOceanFreightBooking: 'Ocean Freight Booking',
    iTMSOceanFreightBookingWorkbench: 'Booking Workbench',
    ITMSOceanBooking: 'Booking List',
    iTMSNewOceanFreightBooking: 'Line',
    OceanFreightBookingWorkbenchBookingDetail: 'Booking Detail',
    OceanFreightBookingWorkbenchBookingChange: 'Modify Commission',
    OceanFreightBookingWorkbenchBookingEdit: 'Booking',
    OceanFreightBookingWorkbenchSiDetail: 'View SI',
    OceanFreightBookingWorkbenchSiEdit: 'Edit SI',
    OceanFreightBookingWorkbenchSiAdd: 'Create SI',
    OceanFreightBookingWorkbenchBLIssuanceDetail: 'Create VGM',
    OceanFreightBookingWorkbenchBLIssuanceEdit: 'Edit VGM',
    OceanFreightBookingNew: 'Line',
    OceanTransitTimeAdd: 'Add Line',
    iTMSdrivingLog: 'Vehicle Logbook',
    iTMSdrivingLogDetail: 'Vehicle Logbook Detail',
    iTMSdrivingLogEdit: 'Edit Vehicle Logbook',
    iTMSdrivingLogAdd: 'Add Vehicle Logbook',
    uploadSI: 'SI Import',
    OceanTransitTimeEdit: 'Edit Line',
    'iTMS-OceanFreightBooking': 'Booking Center',
    iTMSOcean: 'Ocean Freight Booking',
    'Header.index.472095-0': 'Android download',
    'Header.index.472095-1': 'If There Is No Qr Code, Please Contact',
    'Header.index.472095-2': 'International Logistics Bot',
    'Header.index.472095-3': 'IOS download',
    crossBorderRouteOperationImportBill: 'Batch Create LCL Orders',
    'noPermission.index.383813-0a': 'Apply Permission',
    serviceProviderAddContract: 'Edit Contract Information',
    'noPermission.index.383813-0': 'Current Account doesn’t have system permission, please apply (JoyMe Group: 10214980045); Account: {0}, Account Type: {1}',
    airBooking: 'Air Booking Management',
    cabinManagement: 'Flight Management',
    iTMSCabinAllocation: 'Capacity Allocation',
    iTMSAirWaybill: 'AWB',
    iTMSBookingOffice: 'Booking Workbench',
    cabinManagementDetail: 'Flight Details',
    cabinManagementAdd: 'New Flight',
    cabinManagementEdit: 'Edit Flight',
    cabinManagementMultiAdd: 'Batch Flight Creation',
    iTMSCabinAllocationEdit: 'Edit Capacity Allocation',
    iTMSAirWaybillUpload: 'Import AWB',
    importBillCaiji: 'Import Freight Info',
    AutomatedSystemSetting: 'Automated System Configuration',
    OperateSystemSetting: 'OS Configuration',
    IDMSsupplementReositorySecond: 'Auxiliary Function',
    IDMSProductionMonitor: 'Production Monitoring',
    IDMSOperateDetailQuery: 'Operation Query',
    IDMSProcessMonitor: 'Process Monitoring Report',
    IDMSDealedError: 'Exception Handling',
    ITMSTransportTaskUpload: 'Tracking Info Import'
  },
  zh_CN: {
    EmailTemplateManagement: '邮件模板管理',
    SmsTemplateManagement: '短信模板管理',
    iTMSsmsTemplateManagement: '短信模板管理',
    iTMSemailTemplateManagement: '邮件模板管理',
    iTMSNotifyLog: '触达日志',
    NotifyLog: '触达日志',
    TemplateSmsManagement: '短信模板详情',
    emailTemplateDetailManagement: '邮件模板详情',
    airBooking: '空运订舱',
    errorTaskAdd: '异常举证',
    errorTaskDetail: '异常详情',
    cabinManagement: '舱位管理',
    iTMSCabinAllocation: '舱位配额',
    iTMSAirWaybill: '空运票证',
    iTMSBookingOffice: '订舱工作台',
    cabinManagementDetail: '舱位详情',
    cabinManagementAdd: '舱位新增',
    cabinManagementEdit: '舱位编辑',
    cabinManagementMultiAdd: '批量创建舱位',
    iTMSCabinAllocationEdit: '编辑舱位配额',
    iTMSAirWaybillUpload: '导入空运票证',
    importBillCaiji: '批量导入材积',
    importBillMoneyWeight:"批量录入计费重",
    ITMSwayTraceImport: '运单轨迹导入',
    'noPermission.index.383813-0a': '申请权限',
    serviceProviderAddContract: '合同信息编辑',
    crossBorderRouteOperationImportBill: '批量创建拼箱单',
    'Header.index.472095-0': '安卓端下载',
    'Header.index.472095-1': '如无二维码，请联系',
    'driverMap.index.596360-0': '当前位置',
    'driverMap.index.596360-1': '再投',
    'driverMap.index.596360-2': '妥投',
    'driverMap.index.596360-3': '拒收',
    'driverMap.index.596360-4': '未完成',
    'Header.index.472095-2': '国际物流机器人',
    'Header.index.472095-3': 'IOS端下载',
    'noPermission.index.383813-0': '当前账号暂无权限，请先申请开通(京ME群: 10214980045)。账号: {0}，账号类型: {1}',
    iTMSdrivingLog: '行车日志',
    iTMSdrivingLogDetail: '行车日志详情',
    iTMSfeeMsgLog: '计费消息查询',
    iTMSdrivingLogEdit: '编辑行车日志',
    iTMSdrivingLogAdd: '新增行车日志',
    uploadSI: 'SI导入',
    'Header.index.531889-1': '亚太站',
    'Header.index.531889-2': '欧洲站',
    iTMSOcean: '海运订舱',
    'iTMS-OceanFreightBooking': '订舱中心',
    iTMSOceanFreightBooking: '海运订舱',
    iTMSOceanFreightBookingWorkbench: '订舱工作台',
    ITMSOceanBooking: '订舱列表',
    iTMSNewOceanFreightBooking: '干线周期',
    OceanFreightBookingWorkbenchBookingDetail: '订舱单详情',
    OceanFreightBookingWorkbenchBookingChange: '修改委托',
    OceanFreightBookingWorkbenchBookingEdit: '发起订舱',
    OceanFreightBookingWorkbenchSiDetail: '查看SI单',
    OceanFreightBookingWorkbenchSiEdit: '编辑SI单',
    OceanFreightBookingWorkbenchSiAdd: '创建SI单',
    OceanFreightBookingWorkbenchBLIssuanceDetail: '创建VGM',
    OceanFreightBookingWorkbenchBLIssuanceEdit: '编辑VGM',
    OceanTransitTimeAdd: '新增干线周期',
    OceanTransitTimeEdit: '编辑干线周期',
    'vehicleTrajectory.index.551792-0': 'GPS轨迹',
    'vehicleTrajectory.index.551792-1': 'APP轨迹',
    'vehicleTrajectory.index.551792-2': '任务单号',
    'vehicleTrajectory.index.551792-3': '车牌号',
    'vehicleTrajectory.index.551792-4': '开始时间',
    'vehicleTrajectory.index.551792-5': '结束时间',
    'vehicleTrajectory.index.551792-6': 'GPS设备号',
    'vehicleTrajectory.index.890369-1': '运输任务尚未开始行驶',
    'vehicleTrajectory.index.890369-2': '查询任务单失败！',
    'vehicleTrajectory.index.890369-0': '查询任务单行车站点详情',
    'vehicleTrajectory.index.890369-3': '查询任务单行车轨迹',
    LargeServiceMapping: '大件增值服务映射',
    EditLargeServiceMapping: '编辑大件增值服务映射',
    AddLargeServiceMapping: '新增大件增值服务映射',
    ITMSHwlyCarPlanList: '包车计划',
    HwlyCarPlanCreate: '新增包车计划',
    HwlyCarPlanView: '查看包车计划',
    HwlyCarPlanEdit: '编辑包车计划',
    // @ts-ignore
    ...(End2End.LocaleMessage.zh_CN || {}),
    ...luiZh,
    IDMSsupplementReository: '辅助功能',
    IMDSLabelPrint: '标签打印',
    CBRouteTransTaskDetail: '干线运输任务单详情',
    CBRouteTransTaskEdit: '干线运输任务单编辑',
    CBRouteTransTaskAdd: '干线运输任务单新增',
    CBMainRouteTransTaskImportTrace: '干线运输任务单上传轨迹',
    ITMSCBMainRouteTransTaskList: '干线运输任务',
    CrossBorderPortDeliveryOrderAdd: '新增送港运输任务',
    CrossBorderPortDeliveryOrderEdit: '编辑送港运输任务',
    CrossBorderPortDeliveryOrderDetail: '送港运输任务详情',
    ITMSCrossBorderPortDeliveryOrder: '送港运输任务',
    'noPermission.index.692881-0': '国际运力平台',
    'noPermission.index.692881-1': '重新登录',
    'noPermission.index.692881-2': '尊敬的客户，您好！',
    'noPermission.index.692881-3': '新版国际运力平台（itms.jd.com）目前已正式上线，为了更好的享受新版服务体验，请联系销售开通。',
    'noPermission.index.692881-4': '因您当前账号未开通新版工作台系统权限，将返回旧版。',
    'noPermission.index.692881-5': '请联系进入咚咚群',
    'el.table.emptyText': '暂无数据',
    storeManagerUpload: '储位上传',
    MapTracking: '全程跟踪',
    IDMSEndToEndTracking: '全程跟踪',
    ITMSTransportationManage: '陆运管理',
    BookingApprovalDialog: '订舱批复',
    BookingCBAOperation: 'CBA操作',
    BookingStowage: '核对舱单',
    BookingAirlineBooking: '航空订舱',
    CreateTransNeedBill: '新增需求单',
    ModifyTransNeedBill: '修改需求单',
    MergeCreateTaskBill: '创建任务单-合单',
    SplitCreateTaskBill: '创建任务单-拆单',
    TransportationTaskOverseasSendCar: '派车',
    TransportationSingleListDetails: '接单详情',
    'mapTracking.const.759985-0': '揽派网点',
    iTMSStaffManagement: '人员管理',
    iTMSStaffManagementtms: '人员管理',
    iTMSStaffManagement3pl: '人员管理',
    iTMSStaffManagementdms: '人员管理',
    'components.trackingCard.458349-4': '暂时没有数据',
    'Header.index.745653-0': '简体中文',
    'Header.index.745653-1': '用户名',
    'Header.index.745653-2': '退出系统',
    'Header.index.745653-3': '复制成功',
    'Header.index.745653-4': '该浏览器不支持自动复制',
    'Aside.Item.962789-0': '取消收藏',
    'Aside.Item.962789-1': '收藏',
    TransportationTaskListInfo: '运输任务详情',
    BookingSpecifics: '订单详情',
    RouteLclStowageInfo: '拼箱单信息',
    uploadRouteScheduling: '导入排班',
    'home.index.925578-0': '欢迎使用 iTMS',
    ITMSEndToEndTracking: '全程跟踪',
    PostCodeConfiguration: '岗位码配置',
    IDMSMenuPostCodeConfiguration: '岗位码配置',
    'driverMap.index.793895-0': '请输入',
    'driverMap.index.793895-1': '进行中',
    'driverMap.index.793895-2': '已配送',
    'driverMap.index.793895-3': '已揽收',
    'admissionFenceMapDisplay.index.657910-0': '请输入',
    'driverMap.index.745770-0': '该司机今日暂无轨迹',
    'vehicleTrajectory.index.887816-0': '行车轨迹',
    'vehicleTrajectory.index.887816-1': '请输入',
    'vehicleTrajectory.index.887816-2': '车辆：',
    'vehicleTrajectory.index.887816-3': '司机：',
    'lib.request.334593-0': '网络拥挤，请稍候再试~',
    'lib.request.334593-1': '您的账号存在安全风险，请联系客服~',
    'lib.request.334593-2': '系统开小差了，请稍候再试~',

    carManageNewEdit: '查看/编辑车辆',
    ITMSOverseaTrans: '海外陆运',
    ITMSTCManage: '运力管理',
    ITMSWorkbench: '运输调度工作台',
    ITMSDemand: '运输需求管理',
    ITMSHwlyTask: '运输任务管理',
    ITMSVehicleTrajectory: '行车轨迹',
    ITMSOverseasTransExceptionCenter: '异常中心',
    ITMSCarManage: '车辆管理',
    ITMSDriverManage: '司机车辆绑定',
    hwlyTaskDetail: '运输任务详情',
    hwlyDemandDetail: '运输需求详情',
    hwlyWorkbenchBatchDispatch: '运输调度',
    hwlyWorkbenchDemandAdd: '创建需求',

    OperationsReport: '运营报表',
    ConfigCenter: '系统配置',
    AutomatedEquipment: '自动化设备配置',
    WeighMeasureFlowMeter: '称重量方流水表',
    PackageAggregationRules: '集包规则配置',
    BundlingLimitConfig: '集装上限数量配置',
    ErrorManage: '异常管理',

    homePageSite: '揽派首页',
    homePage: '首页',
    ITMSTcscLogisticsPlanDetail: '物流计划详情',
    ITMSTcscLogisticsPlanList: '物流计划管理',
    DispatchManagement: '揽派管理',
    PersonnelManagement: '人员管理',
    DriverBasicInformation: '司机基础信息',
    DriverMap: '司机地图',
    OperationsCenter: '运营中心',
    UnifiedPersonnelEfficiencyDashboard: '人效一表通',
    UnifiedRetentionDashboard: '站内一表通',
    mapTrackingCode: '全程跟踪',
    UnifiedAccountsReceivableDashboard: '应收一表通',
    UnifiedExceptionDashboard: '异常一表通',
    UnifiedPickupDashboard: '取件一表通',
    UnifiedDeliveryDashboard: '派件一表通',
    RouteManagement: '路区管理',
    RouteScheduling: '路区排班',
    AdmissionFenceMapDisplay: '路区围栏',
    TaskWorkbench: '任务工作台',
    EmptyRouteScheduling: '空路区排班',
    CustomerServiceTicketTask: '客服工单任务',
    AddressChangeOrderReplacementTask: '改址换单任务',
    CancelInterceptionTask: '取消拦截任务',
    ZoneTaskAllocation: '任务中心',
    UnifiedFuelSubsidiesDashboard: '油补管理',
    ExportHistory: '导出记录',
    PrintSupplement: '面单补打',
    ReverseSchedule: '返调度',
    StoreManager: '储位管理',
    IDMSStoreManager: '储位管理',
    IDMSStoreManagerUpload: '储位上传',
    ReAssignUnAssginTask: '任务重分配',
    UnCheckPickupEndDetail: '取件终止任务详情',
    Supplement: '辅助功能',
    PayMethodModify: '支付方式',
    PayMethodModifyEdit: '支付方式修改',
    Optlog: 'OTP日志',

    welcomeHomePage: '欢迎来到国际运力平台!',
    noPermission: '暂无权限',
    TransportationDocumentInfo: '运输需求详情',
    CrossBorderListMsg: '基本信息',
    aaa: '姓名',
    Tcsc: '跨境到仓',
    ITMSTcscWaybill: '运输需求',
    ITMSTcscWaybillDetail: '运输需求详情',
    TMSTcscCapacityOrder: '运力单管理',
    TMSTcscCapacityOrderDetail: '运力单详情',
    ITMSTcscTrunkLineOrder: '干线运输任务',
    ITMSTcscTrunkLineOrderDetail: '干线运输任务详情',
    ITMSTcscPortDeliveryOrder: '送港运输任务',
    ITMSTcscPortDeliveryOrderDetail: '送港运输任务详情',
    ITMSTcscWarehouseDeliveryOrder: '送仓运输任务',
    ITMSTcscWarehouseDeliveryOrderDetail: '送仓运输任务详情',
    ITMSTcscWarehouseDeliveryOrderAdd: '新增送仓运输任务',
    // ================= 干线管理 ===================== //
    ItmsTrunkIineManage: '干线管理',

    // -小包管理
    ItmsTrunkIinePackageInfo: '小包管理',
    // --小包列表
    ItmsTrunkIinePackageInfoHome: '小包列表',
    // -大包管理
    ItmsTrunkIinePackageBig: '大包管理',
    // --大包列表
    ItmsTrunkIinePackageBigHome: '大包列表',

    // -提单管理
    ItmsTrunkIineBillInfo: '提单管理',
    // --提单查询
    ItmsTrunkIineShowBillInfo: '提单查询',
    // --报关单导出
    ItmsTrunkIineShowBillInfoEx: '报关单导出',
    // -报表管理
    ItmsTrunkIineReport: '报表管理',
    // --监控报表
    ItmsTrunkIineReportHome: '2C干线时效表',

    // ================= 其他管理 ===================== //
    ItmsOtherManage: '其他管理',

    // -代码评审
    ItmsOtherReviewManage: '代码评审',
    // --我的需求
    ItmsOtherCardInfo: '我的需求',
    // --我的评审
    ItmsOtherReviewInfo: '我的评审',

    // -数据管理
    ItmsOtherDataInfo: '数据管理',
    // --数据操作
    ItmsOtherRunData: '数据操作',

    // ================= 航空管理 ===================== //
    ItmsBookingManage: '航空管理',

    // -基础信息
    ItmsBookingBasicData: '基础信息',
    // --字典管理
    ItmsBookingDictionaryInfo: '字典管理',
    // --城市三字码
    ItmsBookingCityThreeWordCodeInfo: '城市三字码',
    // --承运人
    ItmsBookingCarrierInfo: '承运人',
    // --机型管理
    ItmsBookingAirplaneModelInfo: '机型管理',
    // --客户管理
    ItmsBookingCustomerInfo: '客户管理',
    // --服务商管理
    ItmsBookingServiceProvider: '服务商管理',

    // -航班数据
    ItmsBookingFlightData: '航班数据',
    // --航班载量
    ItmsBookingFlightWorkload: '航班载量',
    // --航班计划
    ItmsBookingFlightPlan: '航班计划',
    // --航班信息
    ItmsBookingFlightInfo: '航班信息',
    // --配额计划
    ItmsBookingDistributePlan: '配额计划',
    // 运单查询
    ItmsObtainTrackingNumber: '运单号取号',
    // -票证管理
    ItmsBookingTicketManage: '票证管理',
    // --票证类型
    ItmsBookingTicketType: '票证类型',
    // --票证信息
    ItmsBookingTicketInfo: '票证信息',
    // --票证分配
    ItmsBookingTicketDistribute: '票证分配',
    // --认领和退票
    ItmsBookingClaimAndRefund: '认领和退票',
    // --票证库存
    ItmsBookingTicketInventory: '票证库存',

    // -订舱管理
    ItmsBookingInfo: '订舱管理',
    // --订单管理
    ItmsBookingShowInfo: '运输需求管理',
    // --航班批复
    ItmsBookingAirlineApproval: '航班批复',
    // --航班转订
    ItmsBookingChange: '航班转订',
    // --代客下单
    ItmsBookingPlaceOrdersForCustomers: '代客下单',

    // -运单管理
    ItmsBookingWaybillInfo: '运单管理',
    // --运单查询
    ItmsBookingShowWaybillInfo: '运单查询',

    // ================= 陆运管理 ===================== //
    ItmsTransportationManage: '陆运管理',

    // -订舱管理
    ItmsTransportationDocumentServices: '运输需求管理',
    // --运输单管理
    ItmsTransportationDocument: '运输需求管理',
    // 接单列表
    ItmsTransportationSingleList: '接单列表',
    // 新需求单管理
    ItmsTransportationDemandOrderManagement: '派车单组单',
    // 计划单管理
    ItmsTransportationScheduleOrderManagement: '派车单管理',
    // 计划单管理详情
    ItmsTransportationScheduleOrderManagementDetail: '派车单管理详情',
    // --代客下单
    ItmsTransportationPlaceOrdersForCustomers: '代客下单',

    // -任务管理
    ItmsTransportationTaskManage: '任务管理',
    // --任务单管理
    ItmsTransportationTaskListManage: '运输任务管理',

    // -基础信息
    ItmsTransportationBasicData: '基础信息',
    // --车辆管理
    ItmsTransportationCarManage: '车辆管理',
    // --司机管理
    ItmsTransportationDriverManage: '司机管理',
    // --车队管理
    ItmsTransportationMotorcadeManage: '车队管理',
    // --我的商家
    ItmsTransportationMyBusiness: '我的商家',
    // --系统配置
    ItmsTransportationDictionaryInfo: '系统配置',
    // --GPS设备
    ItmsTransportationGPSdevice: 'GPS设备',
    // --GPS轨迹
    ItmsTransportationGPStrack: 'GPS轨迹',
    // --导出报表模板
    ItmsTransportationExportReportTemplate: '导出报表模板',
    // --导出报表模板新增
    ItmsTransportationExportReportTemplateAdd: '新增导出报表模板',
    // --导出报表模板编辑
    ItmsTransportationExportReportTemplateEdit: '编辑导出报表模板',

    // ================= 头程揽收 ===================== //
    ITMSCollectionList: '揽收需求',
    ItmsTransportTask: '运输任务',
    ITMSAddCollectionNeed: '新建揽收需求',
    ITMSCreateTransportTask: '创建任务单',
    ITMSCheckCollectionNeed: '查看揽收需求',
    ITMSTransportTaskInfo: '运输任务详情',
    pickupScheduleManagement: '揽收周期配置',
    pickupChannelManagement: '客户揽收渠道配置',
    ITMSEditPickupSchedule: '编辑揽收周期',
    ITMSAddPickupSchedule: '新增揽收周期',
    ITMSEditCollectionNeed: '修改揽收需求',
    // POD解析服务
    ItmsTransportationPodManagement: 'POD批量上传解析',
    // ================= 商服操作 ===================== //
    ItmsSupplierServiceOperation: '港前操作',
    // -跨境列表
    ItmsSupplierServiceCrossBorderList: '跨境列表',
    // 代客下单
    ItmsCrossBorderPlaceOrdersForCustomers: '代客下单',
    ItmsExcelImport: 'Excel导入',
    ItmsPortBatch: 'Excel导入',
    ItmsManualEntry: '手工录入',
    ItmsScatterMining: '服务商询报价',
    // 轨迹导入
    ItmsCrossBorderTrackImport: '轨迹导入',
    ItmsManualEntryFop: '手工录入',

    // ================= 航线操作 ===================== //
    ItmsRouteOperation: '航线操作',
    // -干线周期
    ItmsRouteTrunkCycle: '干线周期',
    // -预配载
    ItmsRoutePreStowage: '预配载',
    // -配载拼箱
    ItmsRouteLclStowage: '配载拼箱',

    // ================= 系统管理 ===================== //
    ItmsSystemManage: '系统管理',

    // ================= 分析报表 ===================== //
    ItmsAnalysisReportFeeList: '分析报表',
    ItmsCostVerification: '费用录入核对',
    ItmsCostVerificationDetail: '费用录入核对-详情',
    ItmsFeeList: '费用管理',
    ItmsLadTrackReport: '提单轨迹跟踪列表',
    Itms_LadTrackLog: '轨迹日志',
    ItmsOrderLog: '订单日志查询',
    Itms_OrderLog: '订单日志查询',

    // -基础信息
    ItmsBasicData: '基础信息',
    // --服务商信息
    ItmsCrossBorderBasicDataServiceProvider: '服务商信息',
    // --商服团队
    ItmsCrossBorderBasicDataBusinessServiceTeam: '商服团队',
    // --国家与城市
    ItmsCrossBorderBasicDataNationalAndCity: '国家与城市',
    // --港口信息
    ItmsCrossBorderBasicDataPort: '港口信息',
    // --船公司
    ItmsCrossBorderBasicDataShippingCompany: '船公司',
    // --航空公司
    ItmsCrossBorderBasicDataAirlines: '航空公司',
    // --集装箱
    ItmsCrossBorderBasicDataContainer: '集装箱',
    // --内部进口商
    ItmsCrossBorderBasicDataImportser: '内部进口商',
    // --内部收货人
    ItmsCrossBorderBasicDataConsignee: '内部收货人',
    // --账号管理
    ItmsCrossBorderBasicDataAccountManage: '账号管理',
    ItmsCrossBorderBasicDataCostTypes: '费用类型',
    ItmsSystemData: '系统配置',
    ItmsSystemDataDictionaryInfo: '字典配置',
    ITMSsenderReceiverInfo: '收发通信息',
    "ITMSsenderReceiverInfoDetail": "收发通信息详情",
    "ITMSsenderReceiverInfoAdd": "收发通信息新增",
    "ITMSsenderReceiverInfoEdit": "收发通信息编辑",
    Itms_AutoBillConfig: '自动计费配置',
    Itms_Postcode: '邮编库',
    ItmsPostcode: '邮编库',
    ItmsAnalysisReport: '分析报表',
    ItmsOperationalAnalysisReport: '运营分析报表',
    PLServiceSupplier: '服务商信息',
    PLDepartmentAuth: '管理部门配置',
    SMTimelinessConfig: 'SPP时效配置',
    PLScatterFilings: '询报价管理',
    PLBiddingManage: '招标书管理',
    PLDemand: '招标需求',
    PLBondManage: '保证金管理',
    PLsystemExecution: '系统执行配置',
    PLemailNotification: '邮件通知配置',
    PLbiddingWorkingGroup: '工作组配置',
    PLCarrier: '服务商产品配置',
    PLCarriePrefix: '服务商单号配置',
    PLConfigLable: '服务商配置',
    PLLogisticsProvider: '服务商配置管理',
    PLLogisticsProviderAttr: '服务商属性管理',
    PLwarningRule: '预警规则配置',
    PLaccountNumber: '账号维护',
    PLCarrierConfig: '承运商配置',
    PLProviderManage: '服务商节点管理',
    PLDockingManage: '服务商对接管理',
    PLMappLable: '服务商节点映射',
    PLBillingImport: '计费导入',
    PLBillingImportWaybill: '审计留痕',
    PLTraceImport: '轨迹导入',
    PLTraceImportB2: '2B轨迹导入',
    PL3PLTranslateList: '翻译管理',
    PLTrackEntryDetails: '轨迹录入详情',
    ALDocTemplate: '模板管理',
    ALDocManager: '单据管理',
    ALShowLabel: '面单管理',
    ALDocTemplate3: '模板管理-V3.0',
    ALDocManager3: '数据源管理-V3.0',
    ALStandardLable: '标准状态',
    ALPackLable: '商家节点包装',
    ALTraceQueryManage: '轨迹日志',
    ALtrackSourceConfig: '轨迹来源配置',
    ALTraceReFetch: '轨迹承运商切换',
    WaybillInquiry: '运单查询',
    WBQueryOrderChain: '订单关系查询',
    WBTrackQuery: '轨迹查询',
    PLAnomalyMonitoringDetails: '包裹异常监控明细表',
    ReportManageAnomalyProcessing: '包裹异常监控处理',
    WBWaybillMonitorNew3pl: '运营监控报表',
    BasicConfiguration: '基础配置',
    SMCountryConfig: '国家配置',
    SMSortingConfig: '分拣码管理',
    SMdictionary3pl: '字典管理',
    'SMdictionary-3pl': '字典管理',
    ToolManagement: '工具管理',
    SMaiTools: '服务商AI工具',
    Itms_RedisTool: '缓存管理',
    SMToolRedis: '缓存管理',
    SMPlaceOrder: '下单管理',
    SMRepushTrace: '轨迹重推',
    SMCodeConfiguration: '单号配置',
    SMExceptionHandle: '异常处理平台',
    SMcommonLog: '日志管理',
    SMServiceLog: '日志查询',
    ITMSReceivableBilling: '自动计费配置',
    // 运输管理
    'ITMS-TransportationManage': '运输管理',
    ITMSCrossBorderFreight: '跨境FBA',
    ITMSSupplierServiceOperation: '港前操作',
    ITMSSupplierServiceCrossBorderList: '跨境列表',
    ITMSCrossBorderPlaceOrdersForCustomers: '代客下单',
    ITMSRouteOperation: '航线操作',
    ITMSRouteTrunkCycle: '干线周期',
    ITMSRoutePreStowage: '预配载',
    ITMSRouteLclStowage: '配载拼箱',
    ITMSbasic: '基础信息',
    ITMSbusinessGroup: '商服团队',
    ITMSserviceProvider: '服务商信息',
    ITMScountAndCity: '国家与城市',
    ITMSportInfo: '港口信息',
    ITMSshipCompany: '船公司',
    ITMSairCompany: '航空公司',
    ITMScabinet: '集装箱',
    ITMSimporter: '内部进口商',
    ITMSreceiver: '内部收货人',
    ITMSaccountManagement: '账号管理',
    ITMSfeeType: '费用类型',
    ITMSAirTransportation: '空运运输',
    ITMSBookingFlightData: '航班数据',
    ITMSBookingFlightWorkload: '航班载量',
    ITMSBookingFlightPlan: '航班计划',
    ITMSBookingFlightInfo: '航班信息',
    ITMSBookingDistributePlan: '配额计划',
    ITMSBookingTicketManage: '票证管理',
    ITMSBookingTicketType: '票证类型',
    ITMSBookingTicketInfo: '票证信息',
    ITMSBookingTicketInventory: '票证库存',
    ITMSBookingInfo: '订单管理',
    ITMSBookingPlaceOrdersForCustomers: '代客下单',
    ITMSOperationalAnalysisReport: '运营分析报表',
    ITMSCostVerification: '费用录入核对',
    ITMSFeeList: '费用管理',
    ITMSLadTrackReport: '提单轨迹跟踪列表',
    ITMSOrderLog: '订单日志查询',
    ITMSCrossBorderTrackImport: '轨迹导入',
    ITMSBookingShowInfo: '运输需求管理',
    ITMSBookingAirlineApproval: '航班批复',
    ITMSBookingChange: '航班转订',
    ITMSBookingShowWaybillInfo: '运单查询',
    ITMSBookingBasicData: '基础信息',
    ITMSBookingCityThreeWordCodeInfo: '城市三字码',
    ITMSBookingDictionaryInfo: '字典管理',
    ITMSBookingCarrierInfo: '承运人',
    ITMSBookingAirplaneModelInfo: '机型管理',
    ITMSBookingCustomerInfo: '客户管理',
    ITMSBookingServiceProvider: '服务商信息',
    ITMSLandTransportation: '陆运运输',
    ITMSTransportationDocumentServices: '运输需求管理',
    ITMSTransportationDocument: '运输需求管理',
    ITMSTransportationPlaceOrdersForCustomers: '代客下单',
    ITMSTransportationTaskManage: '任务管理',
    ITMSTransportationTaskListManage: '运输任务管理',
    ITMSTransportationBasicData: '基础信息',
    ITMSTransportationCarManage: '车辆管理',
    ITMSTransportationDriverManage: '司机管理',
    ITMSTransportationMyBusiness: '我的商家',
    ITMSTransportationMotorcadeManage: '车队管理',
    ITMSTransportationDictionaryInfo: '系统配置',
    ITMSSmallPackageTransportation: '跨境2C',
    ITMSBigSmallPackageManage: '大小包管理',
    ITMSTrunkIinePackageInfoHome: '小包列表',
    ITMSTrunkIinePackageBigHome: '大包列表',
    ITMSTrunkIineBillInfo: '提单管理',
    ITMSTrunkIineShowBillInfo: '提单查询',
    ITMSTrunkIineShowBillInfoEx: '报关单导出',
    ITMSTrunkIineReport: '报表管理',
    ITMSTrunkIineReportHome: '2C干线时效表',
    ITMSSystemManage: '系统管理',
    ITMSSystemData: '系统配置',
    ITMSSystemDataDictionaryInfo: '字典配置',
    PLplatform: '服务商中心',
    '3PL-platform': '服务商中心',
    PLplatformlevel1: '服务商中心',
    PLParamValidation: '接单参数校验',
    PLqueryRule: '查询规则维护',
    WBcarrierTrack3pl: '承运商轨迹监控',
    SystemManagement: '系统管理',
    SMBaseInfo: '基础配置',
    SMFeedBack: '意见收集',
    SMErrorMapping: '异常处理中心',
    SMwaybillQuery: '运单查询',
    PLPeWex: 'pewex导入',
    PLBillingImportOrderId: '订单计费导入',
    WBBidding: '运单中心',
    WBWaybillQuery: '运单查询',
    WBTrackInfo3pl: '物流跟踪',
    WBReportManage: '监控报表',
    WBOrderCount3pl: '单量统计',
    WBPickUpCount3pl: '揽收量',
    WBDeliveredCount3pl: '妥投量',
    WBwarningRuleDetail3pl: '预警明细',
    WBorderTrackStatistics3pl: '时效运营统计',
    ALAbility: '能力中心',
    ALServiceProvider: '服务商管理',
    ALSPInformation: '服务商信息',
    ALBaseInfo: '基础配置',
    PLContractList: '合同管理',
    ALDocumentCenter: '打印中心',
    ALBaseTemplate: '基础模板管理',
    ALBaseTemplate3: '模板管理-V3.0',
    ALTrajectoManage: '轨迹中心',
    PLMappingSchemeManagement: '映射方案管理',
    PLInterfaceConfiguration: '接口能力配置',
    ITMSTransportationSingleList: '接单列表',
    ITMSTransportationDemandOrderManagement: '派车单组单',
    ITMSTransportationScheduleOrderManagement: '派车单管理',
    ITMSTransportationGPSdevice: 'GPS设备',
    ITMSTransportationGPStrack: 'GPS轨迹',
    ITMSTransportationExportReportTemplate: '导出报表模板',
    PrintingCenter: '打印中心',
    TrackingCenter: '轨迹中心',
    OperationalMonitoring: '运营监控',
    SystemTools: '系统工具',
    ServiceProviderMasterData: '服务商主数据',
    ServiceProviderProcurement: '服务商招采',
    ServiceProviderContracts: '服务商合同',
    ServiceProviderIntegration: '服务商系统对接',
    CommonTools: '业务工具',
    MonitoringReports: '监控报表',
    LogisticsManagement: '拣运管理',
    WBWaybillMonitor3pl: '运单监控',
    ITMSAnalysisReport: '业务工具',
    SMObtainTrackingNumber: '运单号取号',
    ITMSSystemDataDictionaryInfo1: '字典配置',
    ITMSObtainTrackingNumber: '运单号取号',
    WBObtainTrackingNumber: '获取运单号',
    PLObtainTrackingNumber: '获取运单号',
    ItmsCollectionListN: '揽收需求',
    ItmsTransportTaskN: '运输任务',
    ItmsPickupChannelManagementN: '揽收渠道管理',
    ItmsPickupScheduleManagementN: '揽收周期配置',
    ITMSFirstCollection: '头程揽收',
    iTMSAutoBillConfig: '自动计费配置',
    ITMSTransportationPodManagement: 'POD批量上传解析',
    PLCollectionImport: '揽收节点导入',
    PLAnomalyMonitoring: '包裹异常监控汇总表',
    ITMSTransportationPromptManage: 'POD批量上传解析',

    'vehicleTrajectory.index.761936-0': '商家提货地址',
    'Header.TopMenu.713567-0': '更多',

    'components.search.413897-0': '请输入JDW单号/FS单号/尾程单号',
    'components.search.413897-1': '搜索',
    'components.search.413897-2': '查询历史',
    'components.search.413897-3': '单号',
    'components.search.413897-4': '请输入单号',
    'components.search.413897-5': '未获取到用户信息',
    'components.search.413897-6': '用户存储信息非数组',
    'components.trackingCard.458349-0': '本地时间',
    'components.trackingCard.458349-1': '最新追踪',
    'components.trackingCard.458349-2': '默认节点',
    'components.trackingCard.458349-3': '轨迹查询失败',
    'mapTracking.const.548220-0': '基础信息',
    'mapTracking.const.548220-1': '订单号',
    'mapTracking.const.548220-2': '客户订单号',
    'mapTracking.const.548220-3': '客户包裹号',
    'mapTracking.const.548220-4': '尾程单号',
    'mapTracking.const.548220-5': '产品名称',
    'mapTracking.const.548220-6': '产品编码',
    'mapTracking.const.548220-7': '服务商产品',
    'mapTracking.const.548220-8': '下单时间',
    'mapTracking.const.548220-9': '客户编码',
    'mapTracking.const.548220-10': '客户名称',
    'mapTracking.const.548220-11': '销售人员',
    'mapTracking.const.548220-12': '是否COD',
    'mapTracking.const.548220-13': 'COD金额',
    'mapTracking.const.548220-14': '税费付款方式',
    'mapTracking.const.548220-15': '寄件信息',
    'mapTracking.const.548220-16': '寄件人姓名',
    'mapTracking.const.548220-17': '寄件人公司',
    'mapTracking.const.548220-18': '寄件人手机',
    'mapTracking.const.548220-19': '寄件人电话',
    'mapTracking.const.548220-20': '寄件人邮箱',
    'mapTracking.const.548220-21': '寄件人国家/地区',
    'mapTracking.const.548220-22': '寄件人全地址',
    'mapTracking.const.548220-23': '寄件人地址经纬度',
    'mapTracking.const.548220-24': '收件信息',
    'mapTracking.const.548220-25': '收件人姓名',
    'mapTracking.const.548220-26': '收件人公司',
    'mapTracking.const.548220-27': '收件人手机',
    'mapTracking.const.548220-28': '收件人电话',
    'mapTracking.const.548220-29': '收件人邮箱',
    'mapTracking.const.548220-30': '收件人国家/地区',
    'mapTracking.const.548220-31': '收件人邮编',
    'mapTracking.const.548220-32': '收件人全地址',
    'mapTracking.const.548220-33': '收件人地址经纬度',
    'mapTracking.const.548220-34': '称重量方信息',
    'mapTracking.const.548220-35': '京东重量KG',
    'mapTracking.const.548220-36': '京东长CM',
    'mapTracking.const.548220-37': '京东宽CM',
    'mapTracking.const.548220-38': '京东高CM',
    'mapTracking.const.548220-39': '京东体积CM³',
    'mapTracking.const.548220-40': '客户预报重量KG',
    'mapTracking.const.548220-41': '客户预报长CM',
    'mapTracking.const.548220-42': '客户预报宽CM',
    'mapTracking.const.548220-43': '客户预报高CM',
    'mapTracking.const.548220-44': '客户预报体积CM³',
    'mapTracking.const.548220-45': '商品信息',
    'mapTracking.const.548220-46': '商品名称',
    'mapTracking.const.548220-47': '商品SKU',
    'mapTracking.const.548220-48': '商品数量',
    'mapTracking.const.548220-49': '商品HSCODE',
    'mapTracking.const.548220-50': '商品重量',
    'mapTracking.const.548220-51': '商品重量单位',
    'mapTracking.const.548220-52': '申报价值',
    'mapTracking.const.548220-53': '图片',
    'mapTracking.const.548220-54': '开箱验视',
    'mapTracking.const.548220-55': '称重量方',
    'mapTracking.const.548220-56': '更改记录',
    'mapTracking.const.548220-57': '操作人',
    'mapTracking.const.548220-58': '操作来源',
    'mapTracking.const.548220-59': '操作时间',
    'mapTracking.const.548220-60': '修改前内容',
    'mapTracking.const.548220-61': '修改后内容',
    'mapTracking.const.548220-62': '接单报文',
    'mapTracking.const.548220-63': '下单报文',
    'mapTracking.const.548220-64': '全部',
    'mapTracking.const.548220-65': '问题件记录',
    'mapTracking.const.548220-66': '客服记录',
    'mapTracking.const.548220-67': '派件记录',
    'mapTracking.const.548220-68': '寄件人邮编',
    'mapTracking.const.548220-69': '司机留言',
    'src.propsMixin.283206-0': '超层照片',
    'src.propsMixin.283206-1': '拆旧照片',
    'src.propsMixin.283206-2': '增值服务照片',
    'mapTracking.dialog.604373-0': '全程跟踪',
    'mapTracking.propsMixin.706968-0': 'JDW单号',
    'mapTracking.propsMixin.706968-1': 'FS单号',
    'mapTracking.propsMixin.706968-2': '尾程单号',

    'mapTracking.const.548221-1': 'DDP寄付',
    'mapTracking.const.548221-2': 'DDU到付',
    'mapTracking.const.548221-3': '第三方付款',

    'mapTracking.const.759985-1': '预分拣揽收站点名称',
    'mapTracking.const.759985-2': '预分拣揽收站点ID',
    'mapTracking.const.759985-3': '预分拣揽收站点编码',
    'mapTracking.const.759985-4': '预分拣派送站点名称',
    'mapTracking.const.759985-5': '预分拣派送站点ID',
    'mapTracking.const.759985-6': '预分拣派送站点编码',
    'src.propsMixin.279961-0': 'SO单号',
    'src.propsMixin.279961-1': '网络类型',
    'src.propsMixin.279961-2': '是否派送自提标识',
    'src.propsMixin.279961-3': '始发仓ID',
    'src.propsMixin.279961-4': '目的仓ID',
    'src.propsMixin.279961-5': '申报价值币种',
    'src.propsMixin.279961-6': '送装一体标识',
    'src.propsMixin.279961-7': '回收服务标识',
    'src.propsMixin.279961-8': '成人签收服务标识',
    'src.propsMixin.279961-9': '高值服务标识',
    'src.propsMixin.279961-10': '纸质签单',
    'src.propsMixin.279961-11': '商品外包装6面照',
    'src.propsMixin.279961-12': '内部包装照片',
    'src.propsMixin.279961-13': '回收证明',
    'src.propsMixin.279961-14': '挂架或座装',
    'src.propsMixin.279961-15': '面签注释及签字',
    'src.propsMixin.279961-16': '铭牌SN码及环境',
    'src.propsMixin.279961-17': '调试信号',
    'src.propsMixin.279961-18': '拒收照片',
    'src.propsMixin.279961-19': '再投照片',
    'src.propsMixin.279961-20': '取件照片',
    'src.propsMixin.279961-21': '再取照片',
    'src.propsMixin.279961-22': '终止取件',
    'src.propsMixin.279961-23': 'POS机小票',
    'src.propsMixin.279961-24': 'COPY单',
    'src.propsMixin.279961-25': 'INVOICE单',
    'src.propsMixin.279961-26': 'MANIFEST单',
    'src.propsMixin.279961-27': '终端异常',
    'src.propsMixin.279961-28': '报废',
    'components.baseInfoCard.500583-0': '中小件',
    'components.baseInfoCard.500583-1': '大件',
    'components.baseInfoCard.500583-2': '冷链',
    'components.baseInfoCard.500583-3': '配送',
    'components.baseInfoCard.500583-4': '自营自提',
    'components.baseInfoCard.500583-5': '加盟自提',
    'components.baseInfoCard.500583-6': '三方自提',
    'tableList.tableList.661328-0': '无安装服务',
    'tableList.tableList.661328-1': '送装一体',
    'tableList.tableList.661328-2': '有回收服务',
    'tableList.tableList.661328-3': '否',
    'tableList.tableList.661328-4': '是',

    'components.baseInfoCard.290487-0': '编码',
    'components.baseInfoCard.290487-1': '名称',
    'components.baseInfoCard.290487-2': '是',
    'components.baseInfoCard.290487-3': '否',
    'components.recordCard.329012-0': '条',
    'components.recordCard.329012-1': '查询失败',
    importQuotationItms: '批量导入报价单',
    AutomatedSystemSetting: '自动化系统配置',
    OperateSystemSetting: '操作系统配置',
    IDMSsupplementReositorySecond: '辅助功能',
    IDMSProductionMonitor: '生产监控',
    IDMSOperateDetailQuery: '操作查询',
    IDMSProcessMonitor: '过程监控报表',
    IDMSDealedError: '异常处理',
    ITMSTransportTaskUpload: '轨迹导入',

    errorTaskDetails: '异常任务详情',
    errorTaskList: '异常任务处理',
    ITMSdmsTaskCenter: '任务中心',
    iTMSprivateNumber: '隐私号管理',
    emailTemplateVersionManagement: '邮件版本列表',
    smsTemplateVersionManagement: '短信版本列表',
    unAssignTaskGroupDetail: '未分配任务组详情',
  }
}
